export const CALENDAR_EVENTS = clubId => `/event/calendar?clubId=${clubId}`;
